export const productSearch = (options) => ({
  savedTerms: [],
  savedCookies: [],
  searchValue: "",
  resultsList: [],
  suggestions: [],
  responseList: { results: [] },
  resultsState: false,
  cursorIndex: -1,
  isOpen: false,
  isLoading: false,

  suggestionUri: options.suggestionUri || "#",
  searchUri: options.searchUri || "#",

  init() {
    this.getSavedTerms();
    this.$refs.searchInput.value = "";
    this.cursorIndex = -1;
  },

  autocompleteContainer: {
    ["@keydown.arrow-up"]() {
      // Move up the list if there is a list and we're not at the top already.
      if (this.suggestions.length > 0 && this.cursorIndex > 0) {
        // Decrement cursorIndex.
        this.cursorIndex--;

        // Remove active status from any other suggestion.
        let oldActive = this.suggestions.find(
          (suggestion) => suggestion.active
        );
        if (oldActive) {
          oldActive.active = false;
        }

        // Add active status to suggestion at cursorIndex.
        this.suggestions[this.cursorIndex].active = true;
        this.$refs.searchInput.value = this.resultsList[this.cursorIndex];
      }
    },

    ["@keydown.arrow-down"]() {
      // Move down the list only if there is room on the list to move down.
      if (
        this.suggestions.length > 0 &&
        this.cursorIndex < this.suggestions.length - 1
      ) {
        // Just increment the cursorIndex.
        this.cursorIndex++;

        // Remove active status from any other suggestion.
        let oldActive = this.suggestions.find(
          (suggestion) => suggestion.active
        );
        if (oldActive) {
          oldActive.active = false;
        }
        this.suggestions[this.cursorIndex].active = true;
        this.$refs.searchInput.value = this.resultsList[this.cursorIndex];
      }
    },

    ["@keydown.escape"]() {
      this.performClearSearch();
    },

    ["@keyup.enter"]() {
      this.getSearchResults(this.$refs.searchInput.value);
    },
  },

  getSearchResults(searchTerm) {
    this.$refs.searchInput.blur();
    this.resultsState = false;
    this.isOpen = false;
    this.isLoading = true;

    const url = new URL(this.searchUri);
    const search_params = url.searchParams;

    search_params.set("query", searchTerm);
    url.search = search_params.toString();

    fetch(url.toString())
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.responseList = data;
        this.resultsState = true;
        this.isOpen = false;
        this.isLoading = false;
        this.saveSearchTerm(searchTerm);
      })
      .catch((error) => {
        this.isLoading = false;
        console.log(error);
      });
  },

  getSuggestions(searchTerm) {
    this.suggestions = [];
    const reg = searchTerm.replace(/\\/g, "");
    const re = new RegExp(reg, "gi");

    this.responseList = [];

    this.resultsList.map((el) => {
      this.suggestions.push(el.replace(re, `<strong>$&</strong>`));
    });
  },

  input: {
    ["@input.debounce"](event) {
      this.searchValue = event.target.value;

      const url = new URL(this.suggestionUri);
      const search_params = url.searchParams;

      search_params.set("term", this.searchValue);
      url.search = search_params.toString();

      fetch(url.toString())
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data && "completions" in data) {
            this.resultsList = data.completions;
            this.getSuggestions(this.searchValue);
            this.isOpen = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    ["@focus"]() {
      this.isOpen = true;
    },

    ["@click.away"]() {
      this.isOpen = false;
    },
  },

  hintsList: {
    ["@click"](event) {
      this.searchValue = event.target.textContent;
      this.$refs.searchInput.value = this.searchValue;
      this.suggestions = [];
      this.getSearchResults(this.searchValue);
      this.cursorIndex = -1;
      this.isOpen = false;
    },
  },

  showResults: {
    ["@click"]() {
      this.getSearchResults(this.searchValue);
    },
  },

  savedTermsList: {
    ["@click"](event) {
      this.searchValue = event.target.textContent;
      this.$refs.searchInput.value = this.searchValue;
      this.getSearchResults(this.searchValue);

      this.suggestions = [];
    },
  },

  clearSearch: {
    ["@click"]() {
      this.performClearSearch();
    },
  },

  performClearSearch() {
    this.$refs.searchInput.value = "";
    this.suggestions = [];
    this.searchValue = "";
    this.isOpen = false;
    this.cursorIndex = -1;

    this.$refs.searchInput.focus();
  },

  modalVisibility: {
    ["@click"]() {
      document.querySelector("body").classList.remove("overflow-hidden");
      this.$refs.searchInput.value = "";
      this.suggestions = [];
      this.resultsState = false;
      this.searchValue = "";
      this.responseList = { results: [] };
      const searchModal = document.querySelector(".search");
      searchModal.classList.toggle("inactive-modal");
    },
  },

  saveSearchTerm(data) {
    let a = [];

    // Parse the serialized data back into an array of objects
    a = JSON.parse(localStorage.getItem("searchTerms")) || [];

    // check if term already exists
    if (a.includes(data)) {
      return;
    }

    // Push the new data
    a.unshift(data);
    this.savedTerms.unshift(data);

    // Re-serialize the array back into a string and store it in localStorage
    localStorage.setItem("searchTerms", JSON.stringify(a));
  },

  getSavedTerms() {
    this.savedTerms = JSON.parse(localStorage.getItem("searchTerms")) || [];
  },
});
